import { faAngleDown } from '@fortawesome/pro-solid-svg-icons'
import { icon } from '@fortawesome/fontawesome-svg-core'
import { createElement } from '../../util/element';

import { listen } from 'ol/events';
import { unByKey } from 'ol/Observable';


import './tree_combobox.css';

import { TreeComboBoxEntry } from "./entry";

class TreeCombobox {
	constructor(options) {
		const { element, rootNodes } = options;
		
		this.rootNodes = rootNodes;
		
		const container = createElement("div", "tree-combobox-container");
		container.appendChild(element);
				
		const button = createElement("div", "tree-combobox-button", container);
		const wrapper = createElement("div", "tree-combobox-wrapper", container);
				
		button.appendChild(icon( faAngleDown ).node[0]);		
		
		element.classList.add("value");
		
		button.addEventListener("click", this.handleButtonClick.bind(this), false);
		element.addEventListener("click", this.handleButtonClick.bind(this), false);
		this.expanded = false;
		this.enabled = true;

		this.element = element;
		this.container = container;
		this.wrapper = wrapper;
		this.button = button;
	}
	
	getElement() {
		return this.container;
	}
	
	isEnabled() {
		return this.enabled;	
	}
	
	setEnabled(enabled) {
		this.enabled = enabled;
	}
	
	getRootNodes() {
		return [];
	}
	
	close() {
		if (this.expanded) {
            unByKey(this.backgroundClickHandler);
            this.backgroundClickHandler = null;
            
            this.wrapper.replaceChildren();
            
            this.expanded = false;
			this.container.classList.remove("expanded");
                        
            this.updateContainerSize();
        }
	}
	
	handleButtonClick(event) {
		if (this.expanded) {
            this.close();
        } else if( this.isEnabled() ) {
			this.backgroundClickHandler = listen(document.body, "click", event => {
				if( !this.container.contains(event.target) ) {
					this.close();
				}
			} );
			
           	this.expanded = true;
           	
           	TreeComboBoxOptions({
				wrapper: this.wrapper,
				rootNodes: this.rootNodes,
				updateContainerSize: () => this.updateContainerSize(),
			});
			this.container.classList.add("expanded");   
            this.updateContainerSize();
    	}        
	}
	
	updateContainerSize() {
		const container = this.container;		
    	container.style.width = '';

    	if( this.expanded ) {
			const wrapper = this.wrapper;
			
    		// HACK temporary style to allow element to tell proper size
        	wrapper.classList.add("widthCalculator");

        	const offsetWidth = wrapper.offsetWidth;
                   	
        	wrapper.classList.remove("widthCalculator");

        	const myWidth = this.element.offsetWidth;
        	const myWidth2 = this.button.offsetWidth;
        	
        	if( offsetWidth > 0 && offsetWidth >= (myWidth + myWidth2) ) {
        		container.style.width = offsetWidth + "px";	
        	} 
    	} 
    	
    }
}

const TreeComboBoxOptions = async (options) => {
	const { wrapper, rootNodes, updateContainerSize } = options;
	
	const element = createElement("div", "tree-combobox-options", wrapper);
	const children = createElement("ul", undefined, element);
	
	element.classList.add("options");
	
	const nodes = await rootNodes();
		
    for( let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        
        new TreeComboBoxEntry({
          node: node,
          container: children,
          updateContainerSize: updateContainerSize
        });
    }
	
	const parent = wrapper.parentElement;
	wrapper.style.top = `${parent.clientHeight}px`;
}

export {
	TreeCombobox
}